new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if(contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if(photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');
    
                    if(photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');
    
                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                              content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }
        
                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                              activeTab(index);
                            });
                        });
                    }
                }
            }

            if(photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 1,
                        vertical: true,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 4,
                                }
                            },
                        ]
                    });
                }else {
                    $('#photo-list').slick({
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: false,
                        rows: 0,
                        variableWidth: false,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 4,
                                }
                            },
                        ]
                    });
                    $('#photo-list').on('init', function(){
                        $(this).slick('setPosition');
                      });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        this.clickThumbs();

        const label = document.querySelector('.product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    let description = document.querySelector('.description-nav');
    if (description) {
        let navTab = description.querySelectorAll('.nav-item');
        let navShow = description.querySelectorAll('.description-nav-content');
        navTab = Array.from(navTab);
        navShow = Array.from(navShow);

        if (navTab.length && navShow.length) {
            navTab[0].classList.add('active');
            navShow[0].classList.add('active');

            function activeTab(index) {
                if (navTab[index].classList.contains('active') && navShow[index].classList.contains('active')) {
                    navTab[index].classList.remove('active');
                    navShow[index].classList.remove('active');
                    return;
                }
                navTab.forEach((content) => {
                    content.classList.remove('active');
                });
                navTab[index].classList.add('active');
                navShow.forEach((content) => {
                    content.classList.remove('active');
                });
                navShow[index].classList.add('active');
            }

            navTab.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    activeTab(index);
                });
            });
        }
    }

    $("body").on("click", ".btn-group.btn-minus", function(event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)){
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function(event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)){
            qtd = 1;
        }else{
            qtd++;
        }
        qt_el.val(qtd);
    });

    if (window.matchMedia("(min-width: 992px)").matches) {
        let lastScrollTop = 0;
    
        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            const banner = document.querySelector('.product-detail__banner');
            const appHeader = document.getElementById('app_header');
            
            if (photoScroll) {
                const infoArea = document.querySelector('.product-detail__header--infoArea');
                const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
                const containerHeight = $container.outerHeight();
                const containerTop = $container.offset() ? $container.offset().top : 0;
                const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
                const containerWidth = $container.width();
                const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
                const pageTop = window.scrollY;
                
                // Verifica se existe banner e calcula quando ele sai da tela
                let bannerOffset = 0;
                if (banner) {
                    const bannerRect = banner.getBoundingClientRect();
                    const bannerHeight = banner.offsetHeight;
                    bannerOffset = bannerHeight;
                }
                
                // Calcula a altura do header para o top na volta
                let headerHeight = 0;
                if (appHeader) {
                    headerHeight = appHeader.offsetHeight;
                }
    
                // Limites de scroll baseados no container e header
                const safeTotalHeight = Math.max(0, totalHeight);
                const startScroll = containerTop - headerHeight; // ponto para começar a fixar
                const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

                if (pageTop <= startScroll) {
                    // Antes do container tocar o header: posição normal
                    $('.sidebar__inner').css({position: 'relative'});
                    $('.sidebar__inner').css({top: "0px"});
                    $('.sidebar__inner').css({width: "100%"});
                    $('.sidebar__inner').css({maxWidth: "100%"});
                } else if (pageTop >= endScroll) {
                    // Depois do final do container: travado no rodapé do container
                    $('.sidebar__inner').css({position: 'relative'});
                    $('.sidebar__inner').css({top: safeTotalHeight + "px"});
                    $('.sidebar__inner').css({width: "100%"});
                    $('.sidebar__inner').css({maxWidth: "100%"});
                } else {
                    // Dentro da faixa: fixo logo abaixo do header e com a largura do container
                    $('.sidebar__inner').css({position: 'fixed'});
                    $('.sidebar__inner').css({top: headerHeight + "px"});
                    if (containerWidth) {
                        $('.sidebar__inner').css({width: containerWidth + "px"});
                        $('.sidebar__inner').css({maxWidth: containerWidth + "px"});
                    }
                }
    
                lastScrollTop = pageTop;
            }
        }
    
        window.addEventListener('scroll', function() {
            if (screen.width > 991) {
                const photoScroll = document.querySelector('.product-detail__header--photoArea');
                if (photoScroll) {
                    animeScroll();
                }
            }
        });
    
        window.onresize = function() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            if (photoScroll) {
                if ($('.sidebar__inner').css('position') === 'fixed') {
                    const infoArea = document.querySelector('.product-detail__header--infoArea');
                    const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
                    const containerWidth = $container.width();
                    if (containerWidth) {
                        $('.sidebar__inner').css({width: containerWidth + "px"});
                        $('.sidebar__inner').css({maxWidth: containerWidth + "px"});
                    }
                }
            }
        };
    } 

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
        
    }

    const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
    if (compreJunto) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
    
                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
    
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
    
                        }
                    }
                });
            });
        });
        
        observer.observe(compreJunto, {
            childList: true,
            subtree: true
        });
        
    }

    if($('.product-detail__header--photoArea-mobile, .mobile-slider')) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 100,
        });
    
        $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();



    if (window.matchMedia("(min-width: 992px)").matches) {
    $('.product-rating__review-list').slick({
      arrows: true,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 700
    });
  }
})